import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Message } from 'semantic-ui-react';
import { sendPasswordForgotMail } from 'api-operations/auth';
import ErrorModal from 'errors/components/ErrorModal';
import { hasErrorCode } from 'logger/error-guards';
import AuthFormLayout from './AuthFormLayout';
import ValidatedInput from './ValidatedInput';
import { useEmail } from './useFieldHooks';
import { StyledForm, StyledButton, ButtonWrapper, FormTitle, FormDescription, AccountLinkText, BackButton, } from './AuthFormStyles';
const SendPasswordReset = () => {
    const email = useEmail();
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [badUser, setBadUser] = useState(false);
    const [errorWindowMessage, setErrorWindowMessage] = useState(null);
    const { t } = useTranslation('common');
    const history = useHistory();
    const params = new URLSearchParams(window.location.search);
    const redirectURL = params.get('redirectURL');
    console.log("asdf", redirectURL);
    const handleSubmit = async () => {
        setLoading(true);
        setBadUser(false);
        try {
            await sendPasswordForgotMail(email.value.toLowerCase(), redirectURL);
            setEmailSent(true);
            setTimeout(function () {
                redirectURL !== null ? window.location.replace(redirectURL) : history.push('/');
            }, 10000);
        }
        catch (error) {
            if (hasErrorCode(401, error)) {
                setBadUser(true);
            }
            else {
                setErrorWindowMessage(error);
            }
        }
        setLoading(false);
    };
    if (errorWindowMessage !== null) {
        return React.createElement(ErrorModal, { ...errorWindowMessage, onClose: () => window.location.reload() });
    }
    return (React.createElement(AuthFormLayout, { showBottomSection: true, bottomSection: React.createElement(AccountLinkText, null,
            React.createElement(BackButton, { onClick: () => redirectURL !== null ? window.location.replace(redirectURL) : history.push('/') },
                React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor" },
                    React.createElement("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" })),
                t('signin.signin'))) },
        React.createElement(StyledForm, { autoComplete: "off", onSubmit: handleSubmit },
            React.createElement(FormTitle, null, t('signin.forgotPasswordHeader')),
            React.createElement(FormDescription, null, t('signin.typeUserOrPass')),
            React.createElement(ValidatedInput, { type: "email", id: "email", value: email.value, onChange: email.handleChange, placeholder: t('settings.email'), errorMessage: email.errorMessage, touched: email.touched, autoFocus: true }),
            emailSent && React.createElement(Message, { positive: true }, t('signin.forgotPasswordMailSent')),
            badUser && React.createElement(Message, { negative: true }, t('signin.badUser')),
            React.createElement(ButtonWrapper, null,
                React.createElement(StyledButton, { loading: loading, disabled: loading || !email.isValid || email.value === '', primary: true, content: t('signin.resetPasswordButton'), type: "submit" })))));
};
export default SendPasswordReset;
